// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"sqa-z"};